import styled from '@emotion/styled'
import { Select, Input, Radio } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import CommonButton from '@/components/common/Button'

export const StyledRadioGroup = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const FullWidthSelect = styled(Select)`
  width: 100%;
`

export const FullWidthInput = styled(Input)`
  width: 100%;
`

export const FullWidthTextArea = styled(Input.TextArea)`
  width: 100%;
`

export const Container = styled('div')`
  width: 100%;
  padding: 40px;
  overflow: hidden;
  position: relative;
`

export const LoadingContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`

export const Header = styled('div')`
  margin-bottom: 32px;
`

export const BackIcon = styled(ArrowLeftOutlined)`
  font-size: 16px;
  color: #000000;
  cursor: pointer;
  margin-right: 10px;
`

export const SubHeader = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const TitleWrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const Title = styled('div')`
  font-weight: 400;
  font-size: 24px;
  margin-bottom: 0px;
  display: flex;
  align-items: center;
`

export const DetailLayout = styled('div')`
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 24px;
  align-items: start;
  width: 100%;
  max-width: 100%;

  @media (max-width: 1400px) {
    grid-template-columns: 1fr 380px;
  }

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`

export const LeftContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const RightContent = styled('div')`
  position: sticky;
  top: 24px;
`

export const Card = styled('div')`
  background: #ffffff;
  border-radius: 8px;
  padding: 32px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
`

export const SectionTitle = styled('div')`
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const InfoGrid = styled('div')`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px 32px;
`

export const Field = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const Label = styled('span')`
  font-size: 12px;
  color: #666666;
  line-height: 16px;
`

export const Value = styled('span')`
  font-size: 16px;
  color: #000000;
  font-weight: 400;
  line-height: 24px;
`

export const MapWrapper = styled('div')`
  height: 450px;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #f0f0f0;
`

export const ActionWrapper = styled('div')`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`

export const StatusBadge = styled('span')<{ bg: string; color: string }>`
  padding: 4px 12px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${(props) => props.bg};
  color: ${(props) => props.color};
  display: inline-flex;
  align-items: center;
`

export const Button = styled(CommonButton)``

export const ButtonSuccessStyle = styled(Button)`
  background-color: #009640;
  color: #ffffff !important;
  border: 0;
  font-size: 16px;
`

export const CoordinatesValue = styled(Value)`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const StyledCopyIcon = styled('span')`
  cursor: pointer;
  display: inline-flex;
  align-items: center;

  img {
    width: 16px;
    height: 16px;
  }
`

export const SupportingText = styled('div')`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  margin-bottom: 24px;
`

export const SupportingTextBold = styled('span')`
  color: #000000;
`

export const RightField = styled(Field)`
  margin-bottom: 24px;
`

export const RightLabel = styled('span')`
  color: #000000;
  font-weight: 500;
`

export const RequiredAsterisk = styled('span')`
  color: #ef2605;
`

export const ErrorText = styled('div')`
  color: #ef2605;
  font-size: 12px;
  margin-top: 4px;
`

export const DetailActionWrapper = styled(ActionWrapper)`
  width: 100%;
  display: flex;
  gap: 12px;
  margin-top: 24px;
`
